import React from 'react';

function Footer() {
  return (
    <footer className="footer-dark">
      <style>{`
        .footer-dark {
          background: linear-gradient(180deg, #0A0B0E 0%, #0B0D12 100%);
          color: #9FB7CC;
          font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, system-ui, sans-serif;
          font-size: 13px;
          text-align: center;
          padding: 24px 16px;
          border-top: 1px solid #1E2330;
          letter-spacing: 0.2px;
        }

        .footer-dark strong {
          color: #46C8FF;
          font-weight: 700;
        }

        .footer-dark a {
          color: #BFEAFF;
          text-decoration: none;
        }

        .footer-dark a:hover {
          text-decoration: underline;
        }
      `}</style>

      © {new Date().getFullYear()} <strong>Berbul.ai</strong> • Broker-integrated execution • Explainable autonomy
    </footer>
  );
}

export default Footer;
